import ProductTypesApi from './ProductTypesApi';
import * as ActionTypes from './ActionTypes';
import IProductType from './IProductType';

function listSuccess(results: IProductType[]) {
    return { type: ActionTypes.LIST_PRODUCT_TYPES_SUCCESS, result: results };
}

function listFailed(result: string) {
    return { type: ActionTypes.LIST_PRODUCT_TYPES_FAILURE, result: result };
}

export function list() {
    return function (dispatch: (result: any) => void, getState: (error: any) => void) {
        return ProductTypesApi.list()
            .then((result: IProductType[]) => {
                dispatch(listSuccess(result));
            })
            .catch((error: string) => {
                dispatch(listFailed(error));
                throw error;
            });
    };
}

function createSucceeded(result: IProductType) {
    return { type: ActionTypes.CREATE_PRODUCT_TYPE_SUCCESS, result: result };
}

function createFailed(error: any) {
    return { type: ActionTypes.CREATE_PRODUCT_TYPE_FAILURE, error: error };
}

export function create(productType: IProductType) {
    return function (dispatch: any, getState: any) {
        return ProductTypesApi.create(productType)
            .then((result: IProductType) => {
                dispatch(createSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(createFailed(error));
                throw error;
            });
    };
}

function newSucceeded(result: any) {
    return { type: ActionTypes.NEW_PRODUCT_TYPE_SUCCESS, result: result };
}

function newFailed(error: any) {
    return { type: ActionTypes.NEW_PRODUCT_TYPE_FAILURE, error: error };
}

export function getNew() {
    return (dispatch: any) =>
        ProductTypesApi.getNew()
            .then((result: any) => {
                dispatch(newSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(newFailed(error));
                throw error;
            });
}

function editSucceeded(result: IProductType) {
    return { type: ActionTypes.EDIT_PRODUCT_TYPE_SUCCESS, result: result };
}

function editFailed(error: string) {
    return { type: ActionTypes.EDIT_PRODUCT_TYPE_FAILURE, error: error };
}

export function edit(id: number) {
    return function (dispatch: (result: any) => void) {
        return ProductTypesApi.edit(id)
            .then((result: IProductType) => {
                dispatch(editSucceeded(result));
            })
            .catch((error: string) => {
                dispatch(editFailed(error));
                throw error;
            });
    };
}

function updateSucceeded(result: IProductType) {
    return { type: ActionTypes.UPDATE_PRODUCT_TYPE_SUCCESS, result };
}

function updateFailed(result: string) {
    return { type: ActionTypes.UPDATE_PRODUCT_TYPE_FAILURE, result };
}

export function update(productType: IProductType) {
    return function (dispatch: (result: any) => void) {
        return ProductTypesApi.update(productType)
            .then((result: any) => {
                dispatch(updateSucceeded(result));
            })
            .catch((error: string) => {
                dispatch(updateFailed(error));
                throw error;
            });
    };
}

function deleteSucceeded(result: number) {
    return { type: ActionTypes.DELETE_PRODUCT_TYPE_SUCCESS, result };
}

function deleteFailed(result: string) {
    return { type: ActionTypes.DELETE_PRODUCT_TYPE_FAILURE, result };
}

export function deleteProductType(id: number) {
    return function (dispatch: (result: any) => void) {
        return ProductTypesApi.delete(id)
            .then((result: any) => {
                dispatch(deleteSucceeded(id));
            })
            .catch((error: string) => {
                dispatch(deleteFailed(error));
                throw error;
            });
    };
}
